import { useNavigate } from "react-router-dom";
import { MdFacebook } from "react-icons/md";
import { BsTwitterX } from "react-icons/bs";
import { FaInstagram } from "react-icons/fa";
import logo from "../asset/logo.svg";
import { useEffect, useState } from "react";
import GetFeatured from "../utiles/Banners/GetFeatured";
import { Category } from "../utiles/types";
import { fetchCategories } from "../services/api";
import logoname from "../asset/maysam/maysam-name.jpg";

const Footer = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedCategories = await fetchCategories();
        setCategories(fetchedCategories);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, 6000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <footer className="bg-white text-black py-16">
      <div className="container mx-auto px-4 max-w-[1400px]">
        {/* Newsletter Section */}
        <div className="mb-16 max-w-[600px] mx-auto text-center">
          <img src={logoname} alt="BlackWilbur" className="w-48 mx-auto mb-8" />
          <h3 className="text-lg mb-4">SIGN UP TO GET 10% OFF YOUR FIRST ORDER</h3>
          <div className="flex gap-2">
            <input
              type="email"
              placeholder="Enter your email address"
              className="flex-1 px-4 py-2 border border-gray-300 focus:outline-none focus:border-black"
            />
            <button className="bg-black text-white px-6 py-2 hover:bg-gray-800 transition-colors">
              →
            </button>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-16 text-sm">
          <div>
            <h4 className="font-medium mb-4">About</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleNavigate('/about-us')} className="hover:underline">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigate('/contact')} className="hover:underline">
                  Contact
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Shop</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((category) => (
                <li key={category.id}>
                  <button 
                    onClick={() => handleNavigate(`/collection/${category.name.toLowerCase()}`)}
                    className="hover:underline"
                  >
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Collections</h4>
            <ul className="space-y-2">
              {categories.slice(4, 8).map((category) => (
                <li key={category.id}>
                  <button 
                    onClick={() => handleNavigate(`/collection/${category.name.toLowerCase()}`)}
                    className="hover:underline"
                  >
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium mb-4">Collections</h4>
            <ul className="space-y-2">
              
                <li>
                  <button 
                    onClick={() => handleNavigate(`/return-policy`)}
                    className="hover:underline"
                  >
                    Delivery & returns
                  </button>
                </li>
                <li>
                  <button onClick={()=>handleNavigate(`/shipping-policy`)}>Shipping Policy</button>
                </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-4">Follow Us</h4>
            <div className="space-y-2">
              <a
                href="https://www.instagram.com/blackwilburofficial"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline block"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/people/Black-Wilbur/61565342369272/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline block"
              >
                Facebook
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline block"
              >
                Pinterest
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Links & Copyright */}
        <div className="text-xs border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600">
              ©2025 Maysam. All rights reserved. designed & developed by <span className="text-pink-600">Cybite</span>
            </p>
            <div className="flex gap-6">
              <button onClick={() => handleNavigate('/terms-and-condition')} className="hover:underline">
                Terms & conditions
              </button>
              <button onClick={() => handleNavigate('/privacy-policy')} className="hover:underline">
                Privacy policy
              </button>
            </div>
          </div> 
        </div>
      </div>

      {/* Popup for GetFeatured */}
      {isPopupOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-60">
          <div className="relative w-full h-screen max-w-3xl flex items-center justify-center p-6 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden">
            <GetFeatured />
            <button
              onClick={togglePopup}
              className="absolute top-2 right-2 text-black text-2xl"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
